export const BANNER = 80;
export const HEADER = 68;
export const REM_UNIT = 16;
